export interface PlanManagement {
  id: string;
  clubId: string;
  planId: string;
  planOrigin: string;
  planTitleJp: string;
  planTitleEng: string;
  planType: string;
  planTime: string;
  noOfPeople: number;
  planPrice: number;
  createdDate: string;
  updatedDate: number;
  status: string;
}

export interface PlanManagementParams {
  search?: string;
  row: number;
  fetch: number;
  clubId?: string;
  fromDate?: number;
  toDate?: number;
}

export interface GetClubPlanDetailParams {
  clubId: string;
  planId: string;
}

export interface GetAdminPlanDetailParams {
  clubId: string;
  planId: string;
}

export const PLAN_ORIGIN = {
  clubPlan: 'Club Plan',
  adminPlan: 'Admin Plan',
};
